/* Insigne — Search/collection grid dedupe
 * Removes any product card that appears more than once in the same grid.
 * Triggered on initial render + after AJAX (infinite scroll, recently-viewed,
 * collection ajax). Defensive: silent no-op if no grid present.
 *
 * Detection: each <li class="product"> typically contains a product link
 * (<a href="/products/HANDLE">). We extract the handle from the first such
 * link and treat it as the unique key for that card.
 */
(function () {
  'use strict';

  const GRID_SELECTORS = [
    '#main-collection-product-grid',
    '.productListing.productGrid',
    '.productGrid',
    '[data-id][class*="productListing"]',
  ];

  function getHandle(card) {
    if (!card) return null;
    const a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    const href = a.getAttribute('href') || '';
    // /products/<handle>?... or /collections/.../products/<handle>?...
    const m = href.match(/\/products\/([^/?#]+)/i);
    return m ? m[1].toLowerCase() : null;
  }

  function dedupe(grid) {
    if (!grid) return 0;
    const cards = grid.querySelectorAll(':scope > li, :scope > .product, :scope > .item, :scope > [data-product-card]');
    const targets = cards.length ? cards : grid.querySelectorAll('li.product, .productCard, .product');
    const seen = new Set();
    let removed = 0;
    targets.forEach((card) => {
      const handle = getHandle(card);
      if (!handle) return;
      if (seen.has(handle)) {
        // Remove duplicate occurrence
        card.parentNode && card.parentNode.removeChild(card);
        removed++;
      } else {
        seen.add(handle);
      }
    });
    return removed;
  }

  function dedupeAll() {
    let total = 0;
    const seen = new WeakSet();
    GRID_SELECTORS.forEach((sel) => {
      document.querySelectorAll(sel).forEach((g) => {
        if (seen.has(g)) return;
        seen.add(g);
        total += dedupe(g);
      });
    });
    return total;
  }

  function init() {
    // Initial pass
    dedupeAll();

    // Watch for new cards added via AJAX (infinite scroll, show-more, recently-viewed injection).
    const observer = new MutationObserver((mutations) => {
      // Only respond when nodes were added (not removed/attribute changes)
      let needsRun = false;
      for (const m of mutations) {
        if (m.addedNodes && m.addedNodes.length) {
          for (const n of m.addedNodes) {
            if (n.nodeType === 1 && (n.matches?.('li, .product, [data-product-card]') || n.querySelector?.('a[href*="/products/"]'))) {
              needsRun = true;
              break;
            }
          }
        }
        if (needsRun) break;
      }
      if (needsRun) {
        // Small debounce — multiple mutations arrive in quick bursts during AJAX
        if (init._t) clearTimeout(init._t);
        init._t = setTimeout(dedupeAll, 50);
      }
    });

    GRID_SELECTORS.forEach((sel) => {
      document.querySelectorAll(sel).forEach((g) => {
        try { observer.observe(g, { childList: true, subtree: false }); } catch (e) {}
      });
    });

    // Also retry after late DOM hydration (some themes inject grid late)
    setTimeout(dedupeAll, 500);
    setTimeout(dedupeAll, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 0);
  }
})();
